import permissions from '../../data/permissions';

export default [
    {
        name: "CreditNoteCreate",
        path: "credit-note",
        component: () => import('./../../views/purchase/CreditNoteCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.credit_note.create }
    },
    {
        name: "CreditNoteDisplay",
        path: "credit-note/:id",
        component: () => import('./../../views/purchase/CreditNoteDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.credit_note.read }
    },
    {
        name: "CreditNoteList",
        path: "credit-notes",
        component: () => import('./../../views/purchase/CreditNoteListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.credit_note.index }
    },
    {
        name: "CreditNoteEdit",
        path: "credit-note/:id/edit",
        component: () => import('./../../views/purchase/CreditNoteEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.credit_note.update }
    }
]